import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Stepper from "./components/Stepper";
import StepperControl from "./components/StepperControl";
import { UseContextProvider } from "./contexts/StepperContext";
import Resource from "./components/steps/Resource";
import Address from "./components/steps/Address";
import Card from "components/card";
import getInputChange from "utils/handleInputChange";
import { useFetchDataId, useCreateData, useUpdateData } from "services/queries";


const Form = () => {
  const resource_path = 'client';
  const resource_name = 'Client';
  const { id } = useParams();
  const isEditMode = Boolean(id);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({ address: {} });
  const navigate = useNavigate();

  const createClient = useCreateData(resource_path);
  const updateClient = useUpdateData(resource_path);

  const { data: client, error: errorClient, isLoading: isLoadingClient } = useFetchDataId('client', id, true);

  useEffect(() => {
    if (client) {
      setFormData(() => client);
    }
  }, [client]);

  const handleInputChange = (e) => {
    getInputChange(e, formData, setFormData)
  };


  const steps = [
    { stepNo: 1, name: `${resource_name} Info` },
    { stepNo: 2, name: `Address Info` },
  ];

  const displayStep = (step) => {
    switch (step) {
      case 1:
        return <Resource
          formData={formData}
          setFormData={setFormData}
          handleInputChange={handleInputChange}
        />;
      case 2:
        return <Address
          formData={formData}
          setFormData={setFormData}
          handleInputChange={handleInputChange}
        />;
      default:
    }
  };

  const handleClick = (direction) => {
    let newStep = currentStep;

    direction === "next" ? newStep++ : newStep--;
    // check if steps are within bounds
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    isEditMode ? updateClient.mutate({ id, newData: formData }) : createClient.mutate(formData);
  };

  useEffect(() => {
    if (isEditMode) {
      if (updateClient.isSuccess) {
        navigate("/admin/client/list");
      }
    }
    else {
      if (createClient.isSuccess) {
        navigate("/admin/client/list");
      }
    }
  }, [updateClient.isSuccess, createClient.isSuccess]);

  if (isLoadingClient) return <div>Loading...</div>;
  if (errorClient) return <div>Error! {errorClient.message}</div>;

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brandLinear to-blueSecondary md:h-[390px]" />
      <div className="w-md:2/3 mx-auto h-full w-5/6 md:px-3  3xl:w-7/12">

        <div className="-mt-[280px] w-full pb-10 md:-mt-[240px] md:px-[70px]">
          <Stepper
            action={setCurrentStep}
            steps={steps}
            currentStep={currentStep}
          />
        </div>
        <Card extra={"h-full mx-auto pb-3"}>
          <form onSubmit={handleSubmit}>

            <div className="rounded-[20px]">

              <UseContextProvider>{displayStep(currentStep)}</UseContextProvider>
            </div>
            {/* navigation button */}
            <StepperControl
              handleClick={handleClick}
              handleSubmit={handleSubmit}
              currentStep={currentStep}
              steps={steps}
            />
          </form>
        </Card>
      </div>
    </div>
  );
};

export default Form;
